// extracted by mini-css-extract-plugin
export default {"headerContainer":"LxWgXGKwGKz5gONMTtq0","titleTextContainer":"AYmmwjtk7C3YC6_bWakl","subtitleTextContainer":"Io7wuxBKov_JhwF1xXvg"};